/**
 * IvaClub Dashboard — Production JavaScript
 * Handles: Smile SDK wiring, panel interactions, social claims,
 * birthday submission, phone number, newsletter, referral copy,
 * skeleton loading states, and points history via proxy.
 *
 * Dependencies:
 *   - Smile.js (loaded globally via app embed)
 *   - Customer data injected via Liquid data attributes on .ic-dashboard
 */

(function () {
  'use strict';

  /* ═══════════════════════════════════════════════════
     SELECTORS
     ═══════════════════════════════════════════════════ */
  var dashboard = document.querySelector('.ic-dashboard');
  if (!dashboard) return;

  /* ── Panel toggle helper ── */
  function togglePanel(panelId, btnId, openText, closedText) {
    var panel = document.getElementById(panelId);
    var btn = document.getElementById(btnId);
    if (!panel || !btn) return;
    var isOpen = panel.classList.toggle('is-open');
    btn.textContent = isOpen ? openText : closedText;
    return isOpen;
  }

  /* ── Mark card completed ── */
  function completeCard(cardId, btnId) {
    var card = document.getElementById(cardId);
    var btn = document.getElementById(btnId);
    if (btn) {
      btn.textContent = 'Realizat \u2713';
      btn.disabled = true;
      btn.classList.remove('ic-btn--primary');
      btn.classList.add('ic-btn--disabled');
    }
    if (card) {
      card.classList.add('ic-earn-card--completed');
    }
  }

  /* ── Persist metafield via CF Worker proxy ── */
  function setMetafield(key) {
    var email = dashboard.dataset.customerEmail;
    if (!email) return;
    fetch('https://ivatherm-smile-proxy.caraulani.workers.dev/metafield', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, key: key, value: 'true' })
    }).then(function (res) {
      if (res.ok) console.log('[IvaClub] Metafield set: ' + key);
      else console.warn('[IvaClub] Metafield error for ' + key + ':', res.status);
    }).catch(function (e) {
      console.warn('[IvaClub] Metafield request failed for ' + key + ':', e);
    });
  }

  /* ═══════════════════════════════════════════════════
     BIRTHDAY
     ═══════════════════════════════════════════════════ */
  // Birthday completion state is handled server-side via Liquid metafield check

  var birthdayToggle = document.getElementById('birthday-toggle');
  if (birthdayToggle) {
    birthdayToggle.addEventListener('click', function () {
      togglePanel('birthday-panel', 'birthday-toggle', 'Ascunde', 'Adaug\u0103 data');
    });
  }

  var birthdaySubmit = document.querySelector('.ic-date-submit');
  if (birthdaySubmit) {
    birthdaySubmit.addEventListener('click', function () {
      var day = document.getElementById('birthday-day').value;
      var month = document.getElementById('birthday-month').value;
      if (!day || !month) return;

      // Send birthday to Smile via Cloudflare Worker proxy
      var smileCustomerId = dashboard.dataset.smileId || dashboard.dataset.smileCustomerId;
      fetch('https://ivatherm-smile-proxy.caraulani.workers.dev/birthday', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          smile_customer_id: smileCustomerId,
          month: parseInt(month, 10),
          day: parseInt(day, 10)
        })
      }).then(function (res) {
        if (res.ok) {
          console.log('[IvaClub] Birthday set on Smile');
        } else {
          console.warn('[IvaClub] Birthday proxy response:', res.status);
        }
      }).catch(function (e) {
        console.warn('[IvaClub] Birthday proxy error:', e);
      });

      // Award points for adding birthday date (one-time custom activity)
      try {
        if (typeof Smile !== 'undefined' && Smile.activities) {
          Smile.activities.create({ token: 'activity_ary0zkw1JG1KBK2362KI1Xno' })
            .then(function () { console.log('[IvaClub] Birthday date activity awarded'); })
            .catch(function (e) { console.warn('[IvaClub] Birthday activity error (may be already claimed):', e); });
        }
      } catch (e) {
        console.warn('[IvaClub] Birthday Smile error:', e);
      }

      setMetafield('ivaclub_birthday_set');
      completeCard('birthday-card', 'birthday-toggle');
      var panel = document.getElementById('birthday-panel');
      if (panel) panel.classList.remove('is-open');
    });
  }

  /* ═══════════════════════════════════════════════════
     SOCIAL CLAIMS (Instagram / Facebook)
     ═══════════════════════════════════════════════════ */
  var socialConfig = {
    instagram: {
      url: 'https://instagram.com/ivatherm',
      activityToken: 'instagram_follow',
      metafieldKey: 'ivaclub_ig_claimed'
    },
    facebook: {
      url: 'https://facebook.com/Ivatherm',
      activityToken: 'facebook_like',
      metafieldKey: 'ivaclub_fb_claimed'
    }
  };

  // Social completion state is handled server-side via Liquid metafield checks

  function claimSocial(platform) {
    var config = socialConfig[platform];
    if (!config) return;

    // Open social page in new tab
    window.open(config.url, '_blank', 'noopener');

    // Award points via Smile legacy SDK (confirmed working method)
    try {
      if (typeof Smile !== 'undefined' && Smile.legacySmile) {
        Smile.legacySmile.createActivity({ token: config.activityToken })
          .then(function () {
            console.log('[IvaClub] ' + platform + ' activity awarded');
          })
          .catch(function (e) {
            // 400 = already claimed (limit 1 per customer) — still mark as done
            console.warn('[IvaClub] ' + platform + ' activity error (may be already claimed):', e);
          });
      }
    } catch (e) {
      console.warn('[IvaClub] Social claim error:', e);
    }

    // Persist via Shopify metafield + update UI
    setMetafield(config.metafieldKey);
    completeCard(platform + '-card', platform + '-btn');
  }

  var igBtn = document.getElementById('instagram-btn');
  if (igBtn) igBtn.addEventListener('click', function () { claimSocial('instagram'); });

  var fbBtn = document.getElementById('facebook-btn');
  if (fbBtn) fbBtn.addEventListener('click', function () { claimSocial('facebook'); });

  /* ═══════════════════════════════════════════════════
     REFERRAL
     ═══════════════════════════════════════════════════ */
  var referralToggle = document.getElementById('referral-toggle');
  if (referralToggle) {
    referralToggle.addEventListener('click', function () {
      togglePanel('referral-panel', 'referral-toggle', 'Ascunde link', 'Distribuie link');
    });
  }

  var copyBtn = document.querySelector('#referral-panel .ic-referral-url-box button');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var input = document.getElementById('referral-url');
      if (!input) return;
      navigator.clipboard.writeText(input.value).then(function () {
        var original = copyBtn.textContent;
        copyBtn.textContent = 'Copiat!';
        setTimeout(function () { copyBtn.textContent = original; }, 2000);
      }).catch(function () {
        // Fallback for older browsers
        input.select();
        document.execCommand('copy');
        var original = copyBtn.textContent;
        copyBtn.textContent = 'Copiat!';
        setTimeout(function () { copyBtn.textContent = original; }, 2000);
      });
    });
  }

  /* ═══════════════════════════════════════════════════
     NEWSLETTER
     ═══════════════════════════════════════════════════ */
  // Check localStorage on load
  if (localStorage.getItem('ivaclub_newsletter_subscribed') === 'true') {
    completeCard('newsletter-card', 'newsletter-btn');
  }

  var newsletterBtn = document.getElementById('newsletter-btn');
  if (newsletterBtn) {
    newsletterBtn.addEventListener('click', function () {
      var email = dashboard.dataset.customerEmail;
      if (!email) return;

      // Already subscribed — do nothing
      if (localStorage.getItem('ivaclub_newsletter_subscribed') === 'true') return;

      // Disable button while submitting
      newsletterBtn.textContent = 'Se trimite...';
      newsletterBtn.disabled = true;

      // Fire custom event to trigger welcome flow (works for new + existing subscribers)
      fetch('https://a.klaviyo.com/client/events/?company_id=WrKW86', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              metric: { data: { type: 'metric', attributes: { name: 'Newsletter Signup' } } },
              profile: { data: { type: 'profile', attributes: { email: email } } },
              properties: { source: 'IvaClub Dashboard' }
            }
          }
        })
      }).catch(function (e) { console.warn('[Newsletter] Event error:', e); });

      // Klaviyo Client Subscriptions API — subscribe to Email List
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=WrKW86', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-10-15'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'IvaClub Dashboard',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email
}
                }
              }
            },
            relationships: {
              list: {
                data: { type: 'list', id: 'Y5wyY9' }
              }
            }
          }
        })
      }).then(function (res) {
        if (res.ok || res.status === 202) {
          console.log('[IvaClub] Newsletter subscribed via Klaviyo');
        } else {
          console.warn('[IvaClub] Klaviyo subscribe response:', res.status);
        }
        localStorage.setItem('ivaclub_newsletter_subscribed', 'true');
        // Update description to tell customer to check email for discount code
        var desc = document.querySelector('#newsletter-card .ic-earn-card-desc');
        if (desc) desc.textContent = 'Mulțumim! Verifică-ți emailul pentru codul tău de reducere -10%.';
        completeCard('newsletter-card', 'newsletter-btn');
      }).catch(function (e) {
        console.warn('[IvaClub] Newsletter subscribe error:', e);
        newsletterBtn.textContent = 'Abonează-te';
        newsletterBtn.disabled = false;
      });
    });
  }

  /* ═══════════════════════════════════════════════════
     PHONE NUMBER
     ═══════════════════════════════════════════════════ */
  // Check localStorage on load
  if (localStorage.getItem('ivaclub_phone_submitted') === 'true') {
    completeCard('phone-card', 'phone-toggle');
    var phonePanel = document.getElementById('phone-panel');
    if (phonePanel) phonePanel.style.display = 'none';
  }

  var phoneToggle = document.getElementById('phone-toggle');
  if (phoneToggle) {
    phoneToggle.addEventListener('click', function () {
      if (localStorage.getItem('ivaclub_phone_submitted') === 'true') return;
      var isOpen = togglePanel('phone-panel', 'phone-toggle', 'Ascunde', 'Adaug\u0103 num\u0103r');
      if (isOpen) {
        var input = document.getElementById('phone-input');
        if (input) input.focus();
      }
    });
  }

  var phoneSubmitBtn = document.querySelector('#phone-panel .ic-inline-input-box button');
  if (phoneSubmitBtn) {
    phoneSubmitBtn.addEventListener('click', function () {
      var input = document.getElementById('phone-input');
      var phone = (input.value || '').replace(/\s/g, '');

      // Normalize Romanian phone: 07xx → +407xx
      if (phone.match(/^0[7][0-9]{8}$/)) {
        phone = '+4' + phone;
      } else if (!phone.startsWith('+')) {
        input.style.borderColor = '#cc0000';
        input.focus();
        return;
      }

      if (phone.length < 12) {
        input.style.borderColor = '#cc0000';
        input.focus();
        return;
      }

      // Disable submit while processing
      phoneSubmitBtn.textContent = 'Se trimite...';
      phoneSubmitBtn.disabled = true;

      var email = dashboard.dataset.customerEmail;

      // Save phone to Shopify customer profile via CF Worker proxy
      fetch('https://ivatherm-smile-proxy.caraulani.workers.dev/phone', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, phone: phone })
      }).then(function (res) {
        if (res.ok) {
          console.log('[IvaClub] Phone saved to Shopify profile');
        } else {
          console.warn('[IvaClub] Phone save response:', res.status);
        }

        // Award Smile points for phone number
        try {
          if (typeof Smile !== 'undefined' && Smile.legacySmile) {
            Smile.legacySmile.createActivity({ token: 'activity_XLiw25uM7g50k5Q6UufQMJ0e' })
              .then(function () { console.log('[IvaClub] Phone activity awarded'); })
              .catch(function (e) { console.warn('[IvaClub] Phone activity error (may be already claimed):', e); });
          }
        } catch (e) {
          console.warn('[IvaClub] Phone Smile error:', e);
        }

        // Show success state
        var panel = document.getElementById('phone-panel');
        var inputBox = panel.querySelector('.ic-inline-input-box');
        var note = panel.querySelector('.ic-expand-note');
        var success = document.getElementById('phone-success');

        if (inputBox) inputBox.style.display = 'none';
        if (note) note.style.display = 'none';
        if (success) success.classList.add('is-visible');

        localStorage.setItem('ivaclub_phone_submitted', 'true');
        completeCard('phone-card', 'phone-toggle');
        setTimeout(function () { if (panel) panel.style.display = 'none'; }, 2000);
      }).catch(function (e) {
        console.warn('[IvaClub] Phone save error:', e);
        phoneSubmitBtn.textContent = 'Salvează';
        phoneSubmitBtn.disabled = false;
      });
    });
  }

  /* ═══════════════════════════════════════════════════
     SMILE SDK INIT — populate live data
     ═══════════════════════════════════════════════════ */
  function removeSkeleton() {
    dashboard.querySelectorAll('.ic-skeleton').forEach(function (el) {
      el.classList.remove('ic-skeleton', 'ic-skeleton--sm', 'ic-skeleton--md', 'ic-skeleton--lg', 'ic-skeleton--points');
    });
  }

  function onSmileReady() {
    if (typeof Smile === 'undefined') return;

    try {
      // Customer data (sync — available immediately after SDK init)
      var customer = Smile.customer.current();
      if (!customer) {
        console.warn('[IvaClub] No Smile customer found');
        removeSkeleton();
        return;
      }

      // Referral URL (available on customer object)
      var refInput = document.getElementById('referral-url');
      if (refInput && customer.referralUrl) {
        refInput.value = customer.referralUrl;
      }

      // Points balance (async)
      Smile.customerPointsWallet.get().then(function (wallet) {
        var balance = wallet.balance || 0;

        var pointsEl = document.querySelector('[data-smile="points-balance"]');
        if (pointsEl) {
          pointsEl.textContent = balance.toLocaleString('ro-RO');
        }

        // Calculate RON value (10 points = 1 lei, from Smile config "10 Points = Lei1")
        var valueEl = dashboard.querySelector('.ic-welcome-points-value strong');
        if (valueEl) {
          var ronValue = (balance / 10).toFixed(2).replace('.', ',');
          valueEl.textContent = ronValue + ' lei';
        }
      }).catch(function (e) {
        console.warn('[IvaClub] Wallet fetch error:', e);
      });

      // Rewards / Coupons (async)
      Smile.rewardFulfillments.get().then(function (fulfillments) {
        if (!fulfillments) return;

        // Filter: unused + issued + not expired.
        // JS SDK uses camelCase (fulfillmentStatus, usedAt) not snake_case.
        // Expiry fails OPEN: an unparseable expiresAt keeps the coupon visible; only a
        // well-formed past date hides it. As of 30 Aug 2026 every fulfillment on this store
        // has expiresAt null (verified live), so this guards future Smile config.
        var now = new Date();
        var unused = fulfillments.filter(function (f) {
          var exp = f.expiresAt ? new Date(f.expiresAt) : null;
          var expired = exp && !isNaN(exp) && exp <= now;
          return f.usedAt === null && f.fulfillmentStatus === 'issued' && !expired;
        });

        // No coupons at all: render empty (hides the section) without a needless proxy round-trip.
        if (unused.length === 0) { renderCoupons([]); return; }

        // Prune codes already deleted from Shopify (revoked via the checkout widget deletes the
        // price rule, but the Smile fulfillment stays "issued" forever). Ask the proxy which codes
        // still exist; drop the dead ones. FAIL-OPEN: on any error, non-OK, or 3s timeout we render
        // the full list exactly as before, and a coupon is dropped only when Shopify EXPLICITLY
        // reports it dead (alive[code] === false). A live coupon can never be hidden by this.
        var couponCtrl = new AbortController();
        var couponTimer = setTimeout(function () { couponCtrl.abort(); }, 3000);
        fetch('https://ivatherm-smile-proxy.caraulani.workers.dev/coupons/status', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ codes: unused.map(function (f) { return f.code; }) }),
          signal: couponCtrl.signal
        }).then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            clearTimeout(couponTimer);
            var alive = (data && data.alive) || {};
            renderCoupons(unused.filter(function (f) { return alive[f.code] !== false; }));
          })
          .catch(function () {
            clearTimeout(couponTimer);
            renderCoupons(unused); // fail-open: show everything
          });

        function renderCoupons(coupons) {
        // Update rewards count in nav card
        var rewardsEl = document.querySelector('[data-smile="rewards-count"]');
        if (rewardsEl) rewardsEl.textContent = coupons.length;

        var section = document.getElementById('coupons-section');
        var list = document.getElementById('coupons-list');
        var desc = document.getElementById('coupons-desc');

        // Idempotent render: onSmileReady can fire up to 3x (smile-js-initialized, smile-ui-loaded,
        // and the already-loaded fallback), and nothing clears the list, so without this reset the
        // coupon cards were appended 2-3x (pre-existing duplicate-render bug). Clearing first makes
        // every render replace, not stack.
        if (list) list.innerHTML = '';

        if (coupons.length === 0) {
          // Empty state — hide section entirely
          if (section) section.style.display = 'none';
          return;
        }

        // Show section only when there are coupons
        if (section) section.style.display = '';

        if (desc) desc.textContent = 'Coduri de reducere disponibile din punctele tale răscumpărate. Copiază codul și folosește-l la checkout.';

        if (!list) return;

        // Extract lei value from name like "Lei100 discount pentru cupon" → "100"
        function extractValue(name) {
          var match = name.match(/Lei(\d+)/i);
          return match ? match[1] : null;
        }

        // Render coupon cards as elegant vouchers
        coupons.forEach(function (coupon, idx) {
          var value = extractValue(coupon.name);

          var card = document.createElement('div');
          card.className = 'ic-coupon-card';
          card.style.animationDelay = (idx * 0.08) + 's';

          // Left: value badge
          var valueSide = document.createElement('div');
          valueSide.className = 'ic-coupon-value';
          if (value) {
            var amount = document.createElement('span');
            amount.className = 'ic-coupon-amount';
            amount.textContent = value;
            valueSide.appendChild(amount);
            var currency = document.createElement('span');
            currency.className = 'ic-coupon-currency';
            currency.textContent = 'lei';
            valueSide.appendChild(currency);
          } else {
            var label = document.createElement('span');
            label.className = 'ic-coupon-amount ic-coupon-amount--sm';
            label.textContent = coupon.name;
            valueSide.appendChild(label);
          }
          card.appendChild(valueSide);

          // Right: details
          var details = document.createElement('div');
          details.className = 'ic-coupon-details';

          var subtitle = document.createElement('div');
          subtitle.className = 'ic-coupon-subtitle';
          subtitle.textContent = 'Reducere la comanda';
          details.appendChild(subtitle);

          var codeRow = document.createElement('div');
          codeRow.className = 'ic-coupon-code-row';

          var codeEl = document.createElement('code');
          codeEl.className = 'ic-coupon-code';
          codeEl.textContent = coupon.code;
          codeRow.appendChild(codeEl);
          details.appendChild(codeRow);

          var actions = document.createElement('div');
          actions.className = 'ic-coupon-actions';

          var copyBtn = document.createElement('button');
          copyBtn.className = 'ic-coupon-copy';
          copyBtn.textContent = 'Copiaza codul';
          copyBtn.addEventListener('click', function () {
            navigator.clipboard.writeText(coupon.code).then(function () {
              copyBtn.textContent = 'Copiat \u2713';
              copyBtn.classList.add('ic-coupon-copy--done');
              setTimeout(function () {
                copyBtn.textContent = 'Copiaza codul';
                copyBtn.classList.remove('ic-coupon-copy--done');
              }, 2500);
            });
          });
          actions.appendChild(copyBtn);

          if (coupon.expiresAt) {
            var expiryEl = document.createElement('span');
            expiryEl.className = 'ic-coupon-expiry';
            var d = new Date(coupon.expiresAt);
            expiryEl.textContent = 'Valabil pana la ' + d.toLocaleDateString('ro-RO');
            actions.appendChild(expiryEl);
          }

          details.appendChild(actions);
          card.appendChild(details);
          list.appendChild(card);
        });

        console.log('[IvaClub] Coupons rendered:', coupons.length);
        } // end renderCoupons
      }).catch(function (e) {
        console.warn('[IvaClub] Coupons fetch error:', e);
      });

      // Store Smile customer ID for birthday proxy + fetch history
      dashboard.dataset.smileId = customer.id;
      fetchHistory(customer.id);

      // Remove skeleton states once we have customer data
      removeSkeleton();

    } catch (e) {
      console.warn('[IvaClub] Smile init error:', e);
      removeSkeleton();
    }
  }

  // Listen for Smile JS SDK initialized event
  document.addEventListener('smile-js-initialized', onSmileReady);

  // Also listen for smile-ui-loaded (app embed event)
  document.addEventListener('smile-ui-loaded', function () {
    // Small delay to ensure Smile object is fully populated
    setTimeout(onSmileReady, 100);
  });

  // Fallback: if Smile SDK is already loaded when our script runs
  if (typeof Smile !== 'undefined' && Smile.customer) {
    onSmileReady();
  }

  /* ═══════════════════════════════════════════════════
     POINTS HISTORY — fetch via app proxy
     ═══════════════════════════════════════════════════ */
  var historyFilled = document.getElementById('history-filled');
  var historyEmpty = document.getElementById('history-empty');
  var historyBody = document.querySelector('#history-filled .ic-history-table tbody');

  // Romanian month abbreviations for date formatting
  var roMonths = ['Ian', 'Feb', 'Mar', 'Apr', 'Mai', 'Iun', 'Iul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function formatDate(dateStr) {
    var d = new Date(dateStr);
    return d.getDate() + ' ' + roMonths[d.getMonth()] + ' ' + d.getFullYear();
  }

  function createCell(className, text) {
    var td = document.createElement('td');
    td.className = className;
    td.textContent = text;
    return td;
  }

  // Romanian overrides for Smile's bad auto-translations
  var descriptionMap = {
    'A sărbătorit o zi de naștere': 'E ziua ta azi, ai un bonus cadou',
    'Added phone number for SMS': 'Ai adaugat un numar de telefon',
    'Urmărit pe Instagram': 'Ne-ai urmarit pe Instagram',
    'Îmi a plăcut pe Facebook': 'Ne-ai dat Like pe Facebook',
    'Subscribed to newsletter': 'Te-ai abonat la newsletter',
    'Completed a purchase': 'Ai plasat o comanda',
    'Made a purchase': 'Ai plasat o comanda',
    'Referred a friend': 'Ai invitat un prieten',
    'Friend made a purchase': 'Un prieten invitat a plasat o comanda',
    'Wrote a product review': 'Ai adaugat o recenzie',
    'Write a product review': 'Adauga o recenzie',
    'Bonus a 3-a comandă acordat': 'Ai primit bonusul la a 3-a comanda'
  };

  function translateDescription(desc) {
    if (descriptionMap[desc]) return descriptionMap[desc];
    // Dynamic spending: "Puncte cheltuite pentru LeiXX discount pentru cupon"
    var spendMatch = desc.match(/Lei(\d+)/i);
    if (spendMatch) return 'Cupon de ' + spendMatch[1] + ' lei utilizat';
    return desc;
  }

  function renderHistory(transactions) {
    if (!historyBody) return;

    if (!transactions || transactions.length === 0) {
      if (historyFilled) historyFilled.style.display = 'none';
      if (historyEmpty) historyEmpty.style.display = 'block';
      return;
    }

    // Clear existing rows
    while (historyBody.firstChild) {
      historyBody.removeChild(historyBody.firstChild);
    }

    transactions.forEach(function (tx) {
      var isPositive = tx.points_change > 0;
      var row = document.createElement('tr');

      row.appendChild(createCell('ic-history-date', formatDate(tx.created_at)));
      row.appendChild(createCell('ic-history-action', translateDescription(tx.description)));

      var pointsClass = 'ic-history-points ' +
        (isPositive ? 'ic-history-points--positive' : 'ic-history-points--negative');
      var pointsText = (isPositive ? '+' : '\u2212') + Math.abs(tx.points_change);
      row.appendChild(createCell(pointsClass, pointsText));

      historyBody.appendChild(row);
    });

    if (historyFilled) historyFilled.style.display = 'block';
    if (historyEmpty) historyEmpty.style.display = 'none';
  }

  // Fetch history from Smile via Cloudflare Worker proxy
  // Uses Smile customer ID (from SDK), not Shopify customer ID
  function fetchHistory(smileCustomerId) {
    if (!smileCustomerId || !historyBody) return;
    fetch('https://ivatherm-smile-proxy.caraulani.workers.dev/history?customer_id=' + encodeURIComponent(smileCustomerId))
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (data && data.points_transactions) {
          renderHistory(data.points_transactions);
        }
      })
      .catch(function (e) {
        console.warn('[IvaClub] History fetch error:', e);
      });
  }

  /* ═══════════════════════════════════════════════════
     SMOOTH SCROLL — nav card anchor links
     ═══════════════════════════════════════════════════ */
  dashboard.querySelectorAll('.ic-nav-link[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = this.getAttribute('href');
      if (href === '#') return;
      var target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

})();
